import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.scss";
import App from './App';
import { AuthProvider } from "./utils/AuthContext/authcontext";
import { NotificationProvider } from "./utils/NotificationContext/NotificationContext";
import { LanguageProvider } from "./utils/LanguageContext/LanguageContext";

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
	<Router>
		<AuthProvider>
		 <LanguageProvider>
		<NotificationProvider>
		<App />
		</NotificationProvider>
		</LanguageProvider>
		</AuthProvider>
	</Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
